import { flowTypes } from '@/common/service/page-config';
import { noop } from 'lodash';

/**
 * Marketing coupon configuration parser service
 * Handles configuration parsing for marketing coupon flows
 */
export class MarketingParserService {
  /**
   * Parse marketing coupon configuration
   * @param {Object} config - Configuration object
   * @param {string} config.promotion - Promotion code
   * @param {string} config.type - Flow type
   * @param {string} config.subPlan - Subscription plan
   * @param {string} config.accountType - Account type
   * @param {Function} getRealFlowTypeByAccountType - Function to get real flow type by account type
   * @param {Function} editConfigParse - Function to parse edit configuration
   * @param {Function} add2cartConfigParse - Function to parse add2cart configuration
   * @param {Function} getEditConfigForNewSubscription - Function to get edit config for new subscription
   * @returns {Object} Parsed configuration result
   */
  static parsePromotionCouponConfig(
    config = {},
    getRealFlowTypeByAccountType = noop,
    editConfigParse = noop,
    add2cartConfigParse = noop,
    getEditConfigForNewSubscription = noop,
  ) {
    let { promotion, type, subPlan } = config;
    let result = {
      type,
      editConfig: {},
      promoCampaignInfo: {
        promotion,
      },
    };

    type = getRealFlowTypeByAccountType(type, config?.accountType);

    if (type === flowTypes.edit) {
      return {
        ...result,
        ...editConfigParse(config),
      };
    } else if ([flowTypes.add2cart, 'add'].includes(type) && subPlan === 'newsubs') {
      return {
        ...result,
        ...add2cartConfigParse(config),
      };
    } else if ([flowTypes.buyNow, flowTypes.basic2pro].includes(type)) {
      return {
        ...result,
        editConfig: getEditConfigForNewSubscription(config)
      };
    }

    return result;
  }
}
